import { render, staticRenderFns } from "./PolicyDocument.vue?vue&type=template&id=9de912e8&scoped=true&"
import script from "./PolicyDocument.vue?vue&type=script&lang=js&"
export * from "./PolicyDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de912e8",
  null
  
)

export default component.exports